export class ComplianceApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async submitVpnAttestation(params) {
        return this.client.post('/api/compliance/vpn-attestation', params);
    }
}
//# sourceMappingURL=compliance-api.js.map